import script from "./MobilePreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobilePreview.vue?vue&type=script&lang=ts&setup=true"

import "./MobilePreview.vue?vue&type=style&index=0&id=53dd42dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53dd42dc"]])

export default __exports__